export default __webpack_public_path__ + "static/logo-de50ad40b1263364a546533c175af981.png";